if (!customElements.get('persistent-search')) {
  class PersistentSearch extends HTMLElement {

    constructor() {
      super();
      this.mobileSearchInput = this.querySelector('input[type="search"]');
      this.mobileSearchSubmit = this.querySelector('button[type="submit"]');
      this.mobileSearchReset = this.querySelector('button[type="reset"]');
      this.mobileSearchInput.addEventListener('focus', this.focusHandler.bind(this));
      this.mobileSearchInput.addEventListener('blur', this.blurHandler.bind(this));
      this.mobileSearchReset.addEventListener('click', this.clickHandler.bind(this));

      const reset = this.mobileSearchReset;
      window.addEventListener('ss.pura.afterBootstrap', (scope) => {
        reset.addEventListener('click', () => {
          scope.detail.pura.ac.close();
        });
      });

      this.mobileSearchToggle = document.querySelector('.mobile-search-btn');
      this.createViewportObserver();
    }

    toggleButtons() {
      [this.mobileSearchSubmit, this.mobileSearchReset].forEach(button => button.classList.toggle('hidden'));
    }

    focusHandler() {
      this.toggleButtons();
    }

    blurHandler() {
      this.toggleButtons();
    }

    clickHandler() {
      this.toggleButtons();
    }

    createViewportObserver() {
      const component = this;
      const callback = function(entries, observer) {
        if (entries[0].isIntersecting) {
          component.mobileSearchToggle.style.opacity = 0;
        } else {
          component.mobileSearchToggle.style.opacity = 1;
        }
      }
      const observer = new IntersectionObserver(callback);
      observer.observe(this);
    }
  }

  customElements.define('persistent-search', PersistentSearch);
}
